import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF, faLinkedinIn, faYoutube, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { getBrokerSiteAsset } from "../../utils";
import HTMLReactParser from 'html-react-parser';
import './BrokerCard.css';

// Adding the enhanced glow effects with three balls
const BrokerCard = ({ brokerData, showContactInfo = false }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    useEffect(() => {
        if (brokerData && brokerData.imgUrl) {
            const img = new Image();
            img.src = brokerData.imgUrl;
            img.onload = handleImageLoad;
        }
    }, [brokerData]);

    if (!brokerData) {
        return <div>No broker data available</div>;
    }

    // Format phone number from 951.536.2288 to (951) 536-2288 for display
    // and +19515362288 for call link
    const formatPhoneNumber = (phoneStr) => {
        if (!phoneStr) return { display: '', call: '' };

        // Remove all non-numeric characters
        const digitsOnly = phoneStr.replace(/\D/g, '');

        // Format for display: (951) 536-2288
        const displayFormat = digitsOnly.length === 10
            ? `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`
            : phoneStr;

        // Format for call link: +19515362288
        const callFormat = digitsOnly.length === 10
            ? `+1${digitsOnly}`
            : `tel:${digitsOnly}`;

        return { display: displayFormat, call: callFormat };
    };

    // Format the phone number
    const phoneNumber = formatPhoneNumber(brokerData?.direct);

    return (
        <div id="BannerBrokerCard" className="broker-card-container">
            <div className="broker-card">
                <div className="broker-image-outer-container">
                    <div className="broker-image-wrapper">
                        {/* Triangle of glowing balls */}
                        <div className="glowing-balls-container">
                            <div className="glowing-ball ball-orange"></div>
                            <div className="glowing-ball ball-mint"></div>
                            <div className="glowing-ball ball-purple"></div>
                        </div>
                        
                        {/* Original image glow effect */}
                        <div className="image-glow"></div>
                        <div className="image-border">
                            <img
                                src={brokerData?.imgUrl ? brokerData?.imgUrl : getBrokerSiteAsset('angelai-logo.webp')}
                                alt={brokerData?.name}
                                className="broker-image"
                                onLoad={handleImageLoad}
                                onError={(e) => {
                                    console.error("Error loading broker image:", e);
                                    e.target.src = "https://via.placeholder.com/150";
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={`${showContactInfo ? "broker-bottom-info" : "broker-info"}`}>
                    <h3 className={`${showContactInfo ? "broker-bottom-name" : "broker-name"}`}>{brokerData?.name}</h3>
                    <p className="broker-title">{HTMLReactParser(brokerData?.title)} | NMLS {HTMLReactParser(brokerData?.nmls)}</p>
                    <p className="broker-company">{HTMLReactParser(brokerData?.companyName)}</p>

                    {/* Conditionally render contact information */}
                    {showContactInfo && (
                        <div className="broker-contact-info">
                            {brokerData?.email && (
                                <a href={`mailto:${brokerData?.email}`} className="broker-email">
                                    {HTMLReactParser(brokerData?.email)}
                                </a>
                            )}

                            {brokerData?.direct && (
                                <a href={`tel:${phoneNumber.call}`} className="broker-phone">
                                    {phoneNumber.display}
                                </a>
                            )}

                            {brokerData?.stateLicenseIn && (
                                <p className="broker-license">
                                    {HTMLReactParser(brokerData?.stateLicenseIn)}
                                </p>
                            )}
                            {brokerData?.address && (
                                <p className="broker-address mb-0">
                                    {HTMLReactParser(brokerData?.address)}
                                </p>
                            )}
                        </div>
                    )}

                    <div className="broker-social-icons">
                        {brokerData?.instagram && (
                            <a href={brokerData?.instagram} target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                        )}
                        {brokerData?.x && (
                            <a href={brokerData?.x} target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                                <FontAwesomeIcon icon={faXTwitter} />
                            </a>
                        )}
                        {brokerData?.facebook && (
                            <a href={brokerData?.facebook} target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                                <FontAwesomeIcon icon={faFacebookF} />
                            </a>
                        )}
                        {brokerData?.linkedin && (
                            <a href={brokerData?.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                        )}
                        {brokerData?.youTubeChannelLink && (
                            <a href={brokerData?.youTubeChannelLink} target="_blank" rel="noopener noreferrer" className="social-icon youtube">
                                <FontAwesomeIcon icon={faYoutube} />
                            </a>
                        )}
                    </div>

                    {!showContactInfo && brokerData?.loID === "WB1G" && (
                        <Button 
                            variant="outline-light" 
                            className="resume-btn"
                            onClick={() => window.open("https://d2w24n4g34usfg.cloudfront.net/brokers-landingpages-resources/resumes/WB1G.pdf", "_blank")}
                        >
                            Resume
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BrokerCard;